
import GridItem from "./GridItem";

export default function Parallax($this) {

    var $objects = $this.find('.js-parallax-object'),
        windowWidth = $(window).width();

    // выключить на мобильных устройствах
    if (windowWidth > 1024) {
        $objects.each((i, object) => new GridItem(object));
    }
};


